import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const LimitSchema = withDefaults({
  type: 'limit',
  fields: [
    {
      kind: 'attribute',
      name: 'product',
    },
    {
      kind: 'attribute',
      name: 'scheme',
    },
    {
      kind: 'attribute',
      name: 'group',
    },
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'annualAmount',
    },
    {
      kind: 'attribute',
      name: 'sixMonthAmount',
    },
    {
      kind: 'attribute',
      name: 'threeMonthAmount',
    },
    {
      kind: 'attribute',
      name: 'taxableAmount',
    },
    {
      kind: 'attribute',
      name: 'hard',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
  ],
});

export default LimitSchema;
